import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';

import { Box, TextField, MenuItem, Button, Dialog, Collapse } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import Add from '@material-ui/icons/Add';
import Edit from '@material-ui/icons/Edit';
import AttorneyRate from './AttorneyRate';
import AlertDialog from '../../Layout/components/AlertDialog';
import Toast from '../../Layout/components/Toast';
import { ADD, EDIT, roleInfo } from '../../../common/common';
import { clone, getNowDate, timeFormat, toMoney } from '../../../common/utils';
import Autocomplete from '@material-ui/lab/Autocomplete';
import UserAutoComplete from '../../Components/UserAutoComplete';
import LegalFeeEditor from './LegalFeeEditor';
import { ExpandMore } from '@material-ui/icons';
import AttorneyRateList from './AttorneyRateList';
import UserTable from './UserTable';


const Root = styled(Box)({
    width: '100%',
    '& .table': {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #D8D8D8',
        '& th': {
            height: '70px',
            backgroundColor: '#EDEDED',
            border: '1px solid #D8D8D8'
        },
        '& td': {
            height: '70px',
            backgroundColor: '#FDFBFE',
            border: '1px solid #D8D8D8'
        },
        '& .textFieldAuto': {
            width: '100px',
        },
        '& .noBorder': {
            border: 'none',
        },
        '& .final': {
            backgroundColor: '#E3EFF7',
            color: '#142D33',
            fontWeight: 'bold',
        },
        '& .finalReport': {
            fontSize: '24px',
        },
        '& .addBtn': {
            verticalAlign: 'top',
        },
        '& .bgTransparent': {
            backgroundColor: 'transparent',
        },
        '& .btn': {
            backgroundColor: '#fff',
        },
        '& .editRate': {
            cursor: 'pointer',
        },
        '& .alias-name': {
            background: '#005e96',
            fontSize: '10px',
            fontWeight: 'bold',
            padding: '2px 8px',
            borderRadius: '15px',
            color: '#ffffff',
        },
        '& .icon-expand': {
            transform: "rotate(0deg)",
            color: "#727272",
        },
        '& .icon-expand-open': {
            transform: "rotate(180deg)",
            color: "#727272",
        },
    },
});

class STable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            showAlert: false,
            showDelAlert: false,
            showDel2Alert: false,
            tempIndex: "",
            total_service_fee: 0,
            arrIndex: 0,
            isAdd: false,
            crtServieId: "",
            crtLegalFee: null,
            expanded: false,

            temp_rate: 0,
            temp_hours: 0,
            temp_amount: 0,
            temp_date: "",
            temp_description: "",
            temp_by: null,
            temp_type: "",
            temp_input_type: "",
            // temp_is_manual_rate: false,
            typeArr: [
                "legal fee",
                "filing fee",
                "Registered Agent Annual Fee",
                "Printing & Mailing Fee",
                "Third Party Fee"
            ],
            timesheetData: [],
            legalData: [],

            invoiceId: "",
            matterId: "",

            showEditor: false,
            showToast: false,
            toastMsg: "",
            toastState: "",
        };
        this.isClickEdit = false;

        this.handleChange = this.handleChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDone = this.handleDone.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleDelItem = this.handleDelItem.bind(this);
        this.handleCreateLegalFee = this.handleCreateLegalFee.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleDelPermanently = this.handleDelPermanently.bind(this);
        this.handleDelOrdinary = this.handleDelOrdinary.bind(this);
        this.handleEditRate = this.handleEditRate.bind(this);
        this.handleEditAllRate = this.handleEditAllRate.bind(this);
        this.updateTempBy = this.updateTempBy.bind(this);
        this.handleCancelItem = this.handleCancelItem.bind(this);
        this.closeEditor = this.closeEditor.bind(this);
    }

    render() {
        const {
            open,
            expanded,
            showAlert,
            showDelAlert,
            showDel2Alert,
            total_service_fee,
            tempIndex,
            temp_rate,
            temp_hours,
            temp_amount,
            temp_date,
            temp_description,
            temp_by,
            temp_type,
            legalData,
            matterId,
            crtServieId,
            crtLegalFee,
            isAdd,
            invoiceId,

            typeArr,

            showEditor,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const { isDisabled } = this.props;
        const editItemView = (timesheet, type, rowItem, varName, variable, isSelectItem, isMoney = false) => {
            if (isSelectItem) {
                if (type === "date") {
                    console.log(variable);
                    return <div className="h h-c">
                        <TextField
                            type="date"
                            variant="outlined"
                            className="textField"
                            value={variable}
                            margin="dense"
                            onChange={e => this.handleChange(e, varName)}
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                } else if (type === "text") {
                    return <div className="h h-c">
                        <TextField
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, varName)}
                            value={variable}
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                } else if (type === "number") {
                    return <div className="h h-c">
                        <TextField
                            type="number"
                            margin="dense"
                            variant="outlined"
                            onChange={e => this.handleChange(e, varName)}
                            value={variable}
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                } else if (type === "tf" && !timesheet) {
                    return <div className="h h-c">
                        <TextField
                            select
                            className="textField"
                            value={variable}
                            onChange={e => this.handleChange(e, varName)}
                            margin="dense"
                            variant="outlined"
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                        >
                            {typeArr.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                } else if (type === "auto" && !timesheet) {
                    console.log("==========");
                    console.log(variable, varName);
                    return <div className="h h-c">
                        <Autocomplete
                            style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                            freeSolo
                            value={variable}
                            onChange={this.handleAutoChange}
                            onInputChange={this.handleAutoInputChange}
                            options={typeArr}
                            renderInput={(params) => (
                                <TextField {...params} margin="dense" variant="outlined" />
                            )}
                        />
                    </div>
                } else if (type === "legalfee") {
                    console.log("==========");
                    console.log(variable, varName);
                    return <div className="h h-c">
                        <div>Legal Fee</div>
                    </div>
                } else if (type === "auto_select") {
                    console.log("==========");
                    console.log(variable, varName);
                    return <div className="h h-c">
                        <UserAutoComplete
                            initUser={variable}
                            update={this.updateTempBy}
                        />
                    </div>
                } else {
                    if (isMoney) {
                        return <div>{rowItem ? "$" + toMoney(rowItem) : "--"}</div>
                    } else {
                        return <div>{rowItem ? rowItem : "--"}</div>
                    }
                }
            } else {
                if (isMoney) {
                    return <div>{rowItem ? "$" + toMoney(rowItem) : "--"}</div>
                } else {
                    return <div>{rowItem ? rowItem : "--"}</div>
                }
            }
        }
        const editItemBtnView = (row, index) => {
            if (tempIndex === index) {

                return <div className="h h-c">
                    <Button disabled={isDisabled} size="small" className="btn" variant="outlined" color="primary"
                        style={{ marginRight: '10px' }} onClick={this.handleDone}>Save</Button>
                    <Button disabled={isDisabled} size="small" className="btn" variant="outlined"
                        onClick={e => this.handleCancelItem(e, row)}>Cancel</Button>
                </div>
            } else {
                return <div className="h h-c">
                    <Button disabled={isDisabled} size="small" className="btn" variant="outlined" color="primary"
                        style={{ marginRight: '10px' }} onClick={e => this.handleEdit(e, index, row)}>Edit</Button>
                    <Button disabled={isDisabled} size="small" className="btn" variant="outlined" color="secondary"
                        onClick={e => this.handleDel(e, row)}>Delete</Button>
                </div>
            }
        }
        return (
            <Root>
                <Collapse className="extend" in={expanded} timeout="auto" unmountOnExit>
                    <AttorneyRateList
                        matterId={matterId}
                        invoiceId={invoiceId}
                        legalData={legalData}
                        handleSave={this.handleEditAllRate}
                    ></AttorneyRateList>
                </Collapse>
                <table className="table" cellPadding={10}>
                    <thead>
                        <tr>
                            {/* <th width="3%">&nbsp;</th> */}
                            <th width="8%">Date</th>
                            <th width="8%">Legal Item</th>
                            <th width="20%">By</th>
                            <th width="22%">Description</th>
                            <th width="8%">Hours</th>
                            <th width="8%" className="editRate">

                                <div className="h h-c" onClick={this.handleEditRate}>
                                    <div>Rate</div>
                                    <ExpandMore className={expanded ? "icon-expand" : "icon-expand-open"} />
                                </div>
                            </th>
                            <th width="10%">Amount</th>
                            <th width="16%">Operation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {legalData.map((row, index) => (
                            <tr key={index}>
                                <td align="center">
                                    {editItemView(row.timesheet, "date", timeFormat(row.date), "temp_date", temp_date, (tempIndex === index))}
                                </td>
                                <td align="center">
                                    {editItemView(row.timesheet, "legalfee", this.changeType(row.type), "temp_type", temp_type, (tempIndex === index))}
                                </td>
                                <td align="center">
                                    {editItemView(row.timesheet, "auto_select", this.handlerName(row), "temp_by", temp_by, (tempIndex === index))}
                                </td>
                                <td align="center">
                                    {editItemView(row.timesheet, "text", row.description, "temp_description", temp_description, (tempIndex === index))}
                                </td>
                                <td align="center">
                                    {editItemView(row.timesheet, "number", row.hours, "temp_hours", temp_hours, (tempIndex === index))}
                                </td>
                                <td align="center">
                                    {editItemView(row.timesheet, "number", row.rate, "temp_rate", temp_rate, (tempIndex === index), true)}
                                </td>
                                <td align="center">
                                    {editItemView(row.timesheet, "number", row.amount, "temp_amount", temp_amount, (tempIndex === index), true)}
                                </td>
                                <td align="center">
                                    {editItemBtnView(row, index)}
                                    {/* <Button disabled={isDisabled} size="small" variant="outlined" color="secondary"
                                        onClick={e => this.handleDel(e, row)}>Delete</Button> */}
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={6}>
                                <Button disabled={isDisabled || isAdd} className="bgTransparent" color="primary"
                                    onClick={e => this.handleAddItem(e, "service")}>
                                    <Add></Add>
                                    <b>ADD A LEGAL FEE</b>
                                </Button>
                            </td>
                            <td className="final noBorder" align="center">Subtotal:</td>
                            <td className="final finalReport noBorder" align="center"
                                colSpan={2}>${total_service_fee ? toMoney(total_service_fee) : "0.00"}</td>
                        </tr>
                    </tbody>
                </table>
                <Dialog maxWidth={false} open={open}>
                    <AttorneyRate
                        handleCreate={this.handleEditAllRate}
                        handleCancel={this.handleCancel}
                        matterId={matterId}
                        data={legalData}
                    ></AttorneyRate>
                </Dialog>
                <Dialog maxWidth={false} open={showDel2Alert}>
                    <div className="c" style={{ width: '600px', padding: '40px' }}>
                        <div style={{ color: "#005E96", fontSize: "18px", fontWeight: "bold", marginBottom: "20px" }}>
                            Do you want to delete ordinary or permanently?
                        </div>
                        <div className="line" style={{
                            width: '90%',
                            height: '1px',
                            backgroundColor: '#A1A1A1',
                            opacity: '0.12',
                            margin: '20px auto',
                        }}></div>
                        <div className="c" style={{ width: "100%" }}>
                            <Button style={{ width: "50%" }} variant="contained" color="primary"
                                onClick={this.handleDelOrdinary}>
                                Ordinary delete
                            </Button>
                            <Button style={{ width: "50%", margin: "15px 0" }} variant="contained" color="secondary"
                                onClick={this.handleDelPermanently}>
                                Permanently delete
                            </Button>
                            <Button style={{ width: "50%" }} variant="contained" onClick={this.handleCloseDialog}>
                                cancel
                            </Button>
                        </div>
                    </div>
                </Dialog>
                <LegalFeeEditor
                    open={showEditor}
                    item={crtLegalFee}
                    itemId={crtServieId}
                    isAdd={isAdd}
                    legalData={legalData}
                    invoiceId={invoiceId}
                    onClose={this.closeEditor}
                ></LegalFeeEditor>
                <AlertDialog
                    open={showAlert}
                    widthSize="md"
                    content="Do you want to add service Items autometically?"
                    yesLabel="NO, I WANT TO ADD MANUALLY"
                    noLabel="YES, I’D LIKE TO ADD AUTOMETICALLY"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
                <AlertDialog
                    open={showDelAlert}
                    content="Do you want to delete the item?"
                    yesLabel="cancel"
                    noLabel="delete"
                    handleAlertYes={this.handleDelItem}
                    handleAlertNo={this.handleCloseDialog}
                ></AlertDialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (this.props.invoiceObj !== prevProps.invoiceObj) {
            const invoiceObj = this.props.invoiceObj;
            if (invoiceObj) {
                const invoiceId = invoiceObj.id;
                const matterId = invoiceObj.matter[0].id;
                const legalData = invoiceObj.legal_fees ? invoiceObj.legal_fees : [];
                this.setState({
                    invoiceId,
                    matterId,
                    legalData
                }, () => {
                    this.updateTotal();
                });
            }
        }
    }

    getLegalFeeList(callback = null) {
        this.getLegalFee(this.state.matterId, (timesheetData) => {
            if (callback) callback(timesheetData);
        });
    }

    handleAddItem(e, name) {
        this.setState(() => ({
            showAlert: true,
            temp_by: null,
        }))
    }

    handleEditRate(e) {
        const { expanded } = this.state;
        this.setState(() => ({
            expanded: !expanded,
            // open: true
        }))
    }

    handleChange(e, name) {
        const value = e.target.value;
        if (name === "temp_hours") {
            const { temp_rate } = this.state;
            this.setState(() => ({
                temp_amount: value * temp_rate
            }));
        } else if (name === "temp_rate") {
            const { temp_hours } = this.state;
            this.setState(() => ({
                // temp_is_manual_rate: true,
                temp_amount: value * temp_hours
            }));
        } else if (name === "temp_amount") {
            this.setState(() => ({
                temp_hours: 0,
                temp_rate: 0,
            }));
        }
        this.setState(() => ({
            [name]: value
        }))
    }

    handleCancelItem(e, row) {
        const { isAdd } = this.state;
        this.isClickEdit = false;
        if (isAdd) {
            this.rmNewItem();
        } else {
            this.clearTempsData();
        }
    }

    handleDel(e, row) {
        const { isAdd, tempIndex } = this.state;
        if (isAdd) {
            const [...legalData] = this.state.legalData;
            legalData.splice(tempIndex, 1);
            this.setState(() => ({
                legalData
            }))
            this.clearTempsData();
            this.clearIsAdd();
        } else {
            if (row.timesheet) {//timesheet service 询问删除方式
                console.log("tiem", row.timesheet)
                this.setState(() => ({
                    crtServieId: row.id,
                    showDel2Alert: true,
                }))
            } else {//普通 service 直接永久删
                console.log("putong", row.timesheet)
                this.setState(() => ({
                    crtServieId: row.id,
                    showDelAlert: true,
                }))
            }
        }
    }

    clickdelLegalFee(isPermDel, legal_fee_id) {
        if (isPermDel) {//永久删除
            console.log("永久删除", legal_fee_id)
            this.delPermLegalFee(this.state.invoiceId, legal_fee_id, () => {
                this.clearTempsData();
                this.clearIsAdd();
                this.props.saveInvoice();
            });
        } else {//普通删除
            console.log("普通删除", legal_fee_id)
            this.delLegalFee(this.state.invoiceId, legal_fee_id, () => {
                this.clearTempsData();
                this.clearIsAdd();
                this.props.saveInvoice();
            });
        }
    }

    //1.获取当前index
    //2.获取row数据并赋值给临时变量
    //3.标记是点击edit的状态
    handleEdit(e, index, row) {
        this.isClickEdit = true;
        this.setState({
            showEditor: true,
            crtServieId: row.id,
            crtLegalFee: row,
            isAdd: false,
        });
        // this.setItemToTemps(index, row);
    }

    closeEditor(status, legal_fee_id) {
        if (status === ADD) {
            const invoice_id = this.state.invoiceId;
            const legal_fee_ids = [legal_fee_id];
            this.addUseLegalFee(invoice_id, legal_fee_ids, () => {
                this.props.saveInvoice();
            });
        } else if (status === EDIT) {
            this.props.saveInvoice();
        }
        this.setState({
            showEditor: false,
            isAdd: false,
        });
    }

    //1.根据获取的index找到data中对应的一条数据
    //2.将临时变量的数据赋值到data对应的obj中
    handleDone(e) {
        this.setTempsToItem();
    }

    handleEditAllRate(changeRateArr, rate) {
        let legalData = clone(this.state.legalData);
        console.log(legalData,changeRateArr)
        for (const legalObj of legalData) {
            for (const changeObj of changeRateArr) {
                if (legalObj.id === changeObj.id && changeObj.check) {
                    legalObj.rate = rate;
                }
            }
        }
        for (const obj of legalData) {
            const params = {
                rate: parseFloat(obj.rate),
            };
            this.editLegalFee(obj.id, params);
        }
        this.setState(() => ({
            legalData
        }))
        // this.closeDialog();
    }

    handleCreateLegalFee(legal_fee_ids) {
        console.log(legal_fee_ids);
        const invoice_id = this.state.invoiceId;
        this.addUseLegalFee(invoice_id, legal_fee_ids, () => {
            this.props.saveInvoice();
        });
        this.closeDialog();
    }

    createService(serviceObj) {
        this.addToServiceList(serviceObj, (legal_fee_id) => {
            this.clearTempsData();
            this.clearIsAdd();
            const invoice_id = this.state.invoiceId;
            const legal_fee_ids = [legal_fee_id];
            this.addUseLegalFee(invoice_id, legal_fee_ids, () => {
                this.props.saveInvoice();
            });
        });
    }

    createLegalFee(servArr) {
        this.setState({
            timesheetData: servArr
        }, () => {
            this.addLegalFeeList();
        });
        this.closeDialog();
    }

    handleCancel() {
        this.closeDialog();
    }

    handleCloseDialog() {
        this.closeDialog();
    }

    closeDialog() {
        this.setState(() => ({
            open: false,
            showDelAlert: false,
            showDel2Alert: false,
        }));
    }

    handleAlertYes() {
        this.setState(() => ({
            showAlert: false,
        }));
        this.openDialog();
    }

    handleAlertNo(isRealClick) {
        this.setState(() => ({
            showAlert: false,
            isAdd: true
        }));
        if (isRealClick) {
            // this.addNewItem();
            this.setState({
                showEditor: true,
                crtServieId: -1,
                crtLegalFee: null,
                isAdd: true,
            });
        }
    }

    handleDelItem() {
        this.setState(() => ({
            showDelAlert: false,
        }));
        this.clickdelLegalFee(true, this.state.crtServieId);
    }

    handleDelPermanently() {
        this.setState(() => ({
            showDel2Alert: false,
        }));
        this.clickdelLegalFee(true, this.state.crtServieId);
    }

    handleDelOrdinary() {
        this.setState(() => ({
            showDel2Alert: false,
        }));
        this.clickdelLegalFee(false, this.state.crtServieId);
    }

    handlerName(row) {
        if (!row) return "";
        const handler = row.handler,
            firstName = handler.first_name ? handler.first_name : "",
            lastName = handler.last_name ? handler.last_name : "",
            alias = row.alias,
            enableAlias = row.enable_alias;

        let name = firstName + " " + lastName;
        if (enableAlias) {
            return <div>
                {name}<br />
                <span className="alias-name">ALIAS: {alias}</span>
            </div>
        }
        return <div>{name}</div>;
    }

    changeType(str) {
        if (str === "legal_fee") return "legal fee";
        return str;
    }

    updateTempBy(temp_by) {
        if (!temp_by) return;
        let temp_rate = this.state.temp_rate;
        // let temp_is_manual_rate = this.state.temp_is_manual_rate;
        if (this.isClickEdit === true) {//点击编辑，第一次不重置rate
            this.isClickEdit = false;
        } else {//添加状态
            temp_rate = temp_by.rate;
            // temp_is_manual_rate = false;
        }
        this.setState(() => ({
            temp_by,
            temp_rate,
            // temp_is_manual_rate
        }));
    }

    addNewItem() {
        const { legalData } = this.state;
        let [...legalDataCopy] = legalData;
        this.clearTempsData();
        const obj = {
            date: getNowDate(),
            type: "",
            description: "",
            hours: 0,
            attorney: 0,
            rate: 0,
            amount: 0,
            is_manual_rate: true,
        }
        legalDataCopy.push(obj);
        this.setState(() => ({
            legalData: legalDataCopy,
            tempIndex: legalDataCopy.length - 1,
        }))
    }

    rmNewItem() {
        const { legalData } = this.state;
        let [...legalDataCopy] = legalData;
        this.clearTempsData();
        legalDataCopy.splice(legalDataCopy.length - 1, 1);
        this.setState(() => ({
            legalData: legalDataCopy,
            tempIndex: "",
            isAdd: false
        }))
    }

    setItemToTemps(index, obj) {
        console.log(obj);
        this.active = false;
        this.setState(() => ({
            tempIndex: index,
            temp_date: obj.date ? getNowDate(obj.date) : "",
            temp_type: obj.type ? obj.type : "",
            temp_description: obj.description ? obj.description : "",
            temp_hours: obj.hours ? obj.hours : 0,
            temp_attorney: obj.attorney ? obj.attorney : 0,
            temp_rate: obj.rate ? obj.rate : 0,
            temp_amount: obj.amount ? obj.amount : 0,
            temp_by: obj.handler,
        }));
        // if (obj.hasOwnProperty("is_manual_rate")) {
        //     this.setState(() => ({
        //         temp_is_manual_rate: obj.is_manual_rate
        //     }));
        // }
    }

    setTempsToItem() {
        const {
            isAdd,
            tempIndex,
            legalData,
            temp_rate,
            temp_hours,
            temp_amount,
            temp_date,
            temp_description,
            temp_by,
        } = this.state;
        let [...legalDataCopy] = legalData;
        let obj = legalDataCopy[tempIndex];
        obj.date = temp_date;
        obj.serviceItem = "Legal Fee";//default type here
        obj.description = temp_description;
        obj.hours = Number(temp_hours);
        obj.rate = Number(temp_rate);
        obj.is_manual_rate = true;
        if (temp_by === null) {
            obj.handler_id = roleInfo.identity.id;
        } else {
            obj.handler_id = temp_by.id;
        }
        console.log(roleInfo);
        console.log(temp_by);
        console.log(obj);
        // obj.amount = Number(obj.hours * obj.rate).toFixed(2);
        obj.amount = Number(temp_amount);
        console.log(isAdd);
        if (isAdd) {
            this.createService(obj);
        } else {
            const params = {
                rate: obj.rate,
                hours: obj.hours,
                amount: Number(obj.amount),
                date: (Date.parse(obj.date) / 1000).toString(),
                description: obj.description,
                type: obj.serviceItem,
                handler_id: obj.handler_id,
                is_manual_rate: true,
            };
            this.editLegalFee(obj.id, params);
        }
        // this.setState({
        //     legalData: legalDataCopy
        // }, () => {
        //     this.updateTotal();
        //     this.clearTempsData();
        // })
    }

    openDialog() {
        //使用弹窗
        // this.setState(() => ({
        //     open: true,
        // }));
        //直接加入
        this.getTimesheet();
        this.clearTempsData();
    }

    clearTempsData() {
        this.setState(() => ({
            tempIndex: "",
            temp_date: getNowDate(),
            temp_type: "",
            temp_description: "",
            temp_hours: 0,
            temp_attorney: 0,
            temp_rate: 0,
            temp_amount: 0
        }));
    }

    clearIsAdd() {
        this.setState(() => ({
            isAdd: false
        }));
    }

    updateTotal() {
        const { legalData } = this.state;
        let total_service_fee = 0;
        for (const obj of legalData) {
            total_service_fee += Number(obj.amount);
            console.log("sss", obj)
        }
        this.setState(() => ({
            total_service_fee: Number(total_service_fee).toFixed(2)
        }))

    }

    addLegalFeeList() {
        this.loopAddLegal();
    }

    loopAddLegal() {
        const { timesheetData, arrIndex } = this.state;
        console.log("循环头")
        let obj = timesheetData[arrIndex];
        this.addToServiceList(obj, () => {
            let arrIndexCopy = arrIndex;
            arrIndexCopy++;
            this.setState({
                arrIndex: arrIndexCopy
            }, () => {
                if (this.state.arrIndex === timesheetData.length) {
                    this.getLegalFeeList((servData) => {
                        console.log("servData====================")
                        console.log(servData)
                        this.setState(() => ({
                            arrIndex: 0
                        }))
                        const invoice_id = this.state.invoiceId;
                        const legal_fee_ids = this.getIds(servData);
                        this.addUseLegalFee(invoice_id, legal_fee_ids, () => {
                            this.props.saveInvoice();
                        });
                    })
                } else {
                    this.loopAddLegal();
                }
            });
        });
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    getIds(legalData) {
        let idsArr = [];
        for (const obj of legalData) {
            idsArr.push(obj.id);
        }
        return idsArr;
    }

    // this.createLegalFee(servArr);
    //----------------request-------------------------------
    getTimesheet() {
        const { matterId } = this.state;
        const params = {
            matter_id: matterId
        }
        instance.get(BASE_URL + 'billing/legal_fee', { params }).then((res) => {
            const legalData = res.data.data;
            console.log("=legalData=", legalData)
            let legalIdArr = [];
            for (const servObj of legalData) {
                legalIdArr.push(servObj.id);
            }
            if (legalIdArr.length > 0) {
                this.handleCreateLegalFee(legalIdArr)
            } else {
                this.showToast("No more data", "success");
            }
        })
    }

    getLegalFee(matter_id, callback = null) {
        let params = {
            matter_id
        }
        instance.get(BASE_URL + 'billing/legal_fee', { params }).then((res) => {
            const timesheetData = res.data.data;
            if (callback) callback(timesheetData);
        })
    }

    addToServiceList(obj, callback) {
        const params = {
            rate: obj.rate,
            hours: obj.hours,
            amount: Number(obj.amount),
            date: (Date.parse(obj.date) / 1000).toString(),
            description: obj.description,
            type: obj.serviceItem,
            handler_id: obj.handler_id,
            is_manual_rate: true,
        }
        instance.post(BASE_URL + 'billing/legal_fee', params).then((res) => {
            console.log("===========legal_fee id================")
            console.log(res.data.data.id)
            const legal_fee_id = res.data.data.id;
            callback(legal_fee_id);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    addUseLegalFee(invoice_id, legal_fee_ids, callback) {
        const params = {
            legal_fee_ids
        }
        console.log(legal_fee_ids);
        instance.post(BASE_URL + 'billing/invoices/' + invoice_id + '/legal_fee', params).then((res) => {
            this.showToast("Added " + legal_fee_ids.length + " legal fee successfully", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    //永久删除
    delPermLegalFee(invoice_id, legal_fee_id, callback) {
        console.log(invoice_id, legal_fee_id)
        instance.delete(BASE_URL + 'billing/invoices/' + invoice_id + '/legal_fee/' + legal_fee_id).then((res) => {
            this.showToast("Successfully deleted", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    //普通删除
    delLegalFee(invoice_id, legal_fee_id, callback) {
        const params = {
            legal_fee_ids: [legal_fee_id]
        }
        instance.delete(BASE_URL + 'billing/invoices/' + invoice_id + '/legal_fee', { data: params }).then((res) => {
            this.showToast("Successfully deleted", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    editLegalFee(legal_fee_id, params) {
        console.log(params);
        instance.put(BASE_URL + 'billing/legal_fee/' + legal_fee_id, params).then((res) => {
            this.showToast("Successfully modified", "success");
            this.clearTempsData();
            this.props.saveInvoice();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    getInvoiceRate(invoice_id, user_id, callback) {
        instance.get(BASE_URL + `billing/invoices/${invoice_id}/users/${user_id}/rate`).then((res) => {
            const rateData = res.data.data;
            console.log("rateData", rateData)
            if (callback) callback();
        })
    }
}

export default STable;